module.exports = __webpack_public_path__ + "media/images/landing/logo-sama-9dd09e3f657ac27aba08bf21e67b4131.png";